<template>
    <v-card class="dialog" :value="value" @input="$emit('input', $event)" width="520">
        <v-card-title class="primary">
            <span class="headline">{{ title }}</span>
        </v-card-title>

        <v-card-text class="dialog-body">
            <div class="message">{{ message }}</div>
        </v-card-text>

        <v-card-actions class="dialog-actions">
					<v-layout row wrap align-center justify-center>
						<v-btn
							flat
							class="btn-cancel"
							@click="onCancel"
							:disabled="disableButtons"
						>
							{{ cancelText }}
						</v-btn>

						<div style="width:24px"></div>

						<v-btn
							class="button-permanecer"
							flat
							@click="onConfirm"
							:disabled="disableButtons"
						>
							{{ confirmText }}
						</v-btn>
					</v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
	export default {
		name: "ConfirmationDialog",
		props: {
			value: { type: Boolean, required: true },
			title: { type: String, default: "Confirmação" },
			message: { type: String, default: "Deseja continuar?" },
			confirmText: { type: String, default: "CONFIRMAR" },
			cancelText: { type: String, default: "CANCELAR" },
			disableButtons: { type: Boolean, default: false }
		},
		methods: {
			onCancel() {
				this.$emit("cancel");
				this.$emit("input", false);
			},
			onConfirm() {
				this.$emit("confirm");
				this.$emit("input", false);
			}
		}
	};
</script>

<style scoped>
.dialog-title {
  background-color: #0b4f6a;
  color: white;
  padding-top: 14px;
  padding-bottom: 14px;
}
.dialog-body {
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 28px;
  padding-bottom: 28px;
}
.message {
  color: #9b9b9b;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.6px;
}
.dialog-actions { padding: 20px 24px 28px 24px; justify-content: center; }
.v-btn.btn-cancel {
  border: 2px solid #0b4f6a;
  color: #0b4f6a;
  text-transform: uppercase;
  font-weight: 600;
  min-width: 160px;
}
.btn-confirm {
  background-color: #0b4f6a;
  color: white;
  text-transform: uppercase;
  font-weight: 600;
  min-width: 160px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/frota/ModalConfirmacaoEmissao.vue